import { render } from "./form_8.vue?vue&type=template&id=fdc1c582"
import script from "./form_8.vue?vue&type=script&lang=js"
export * from "./form_8.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_8.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fdc1c582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fdc1c582', __exports__)) {
    console.log('reload')
    api.reload('fdc1c582', __exports__)
  }
  
  module.hot.accept("./form_8.vue?vue&type=template&id=fdc1c582", () => {
    console.log('re-render')
    api.rerender('fdc1c582', render)
  })

}


export default __exports__